import {ConfigType} from "../types/types";

export const DEFAULT_CONFIG:ConfigType = {
    tileCardTemplate: (vCard) => {
        return `<div><h1>${vCard.text}</h1></div>`;
    },
    railCardTemplate: (vCard) => {
        return `<div><h1>${vCard.text}</h1></div>`;
    },
    viewType: 'tile',
    draggable: true,
    filterFunc: (vInputText, vCard) => {
        return true;
    },
    tileCardHeight: 200,
    tileCardWidth: 200,
    railCardHeight: 100,
    railCardWidth: 600,
    searchInput: "",
    emptyCardFile:
        {
            header:"Список пуст",
            description:"Добавьте новые карточки",
            imageSrc:"",
        }
}
